// Fondo de todos los modales del sistema. Tocar fuera NO cierra: se cierra con ESC, la X, Cancelar o Cerrar,
// o desde la pantalla después de guardar (eso no pasa por aquí). Si se escribió algo, pide confirmar antes de salir.
import React, { useCallback, useEffect, useRef } from 'react';
import Swal from 'sweetalert2';

const ES_CIERRE = /^(cancelar|cerrar|×|x)$/i;
const esBotonDeCierre = (b) => b.getAttribute('aria-label') === 'Cerrar' || ES_CIERRE.test(b.textContent.trim());

/** `confirmar={false}`: el modal maneja sus propios cambios. `esc={false}`: maneja su propia tecla Escape. */
export default function FondoModal({ onClose, className = 'fx-backdrop', style, confirmar = true, esc = true, children }) {
  const fondo = useRef(null);
  const cambios = useRef(false);
  const cerrar = useRef(onClose);
  cerrar.current = onClose;

  const seguirSinGuardar = useCallback(async () => {
    if (!confirmar || !cambios.current) return true;
    const r = await Swal.fire({ title: 'Hay cambios sin guardar', text: 'Si sales ahora, se perderán.', icon: 'warning', showCancelButton: true,
      confirmButtonText: 'Salir sin guardar', cancelButtonText: 'Seguir editando', reverseButtons: true, focusCancel: true });
    if (r?.isConfirmed) cambios.current = false;
    return !!r?.isConfirmed;
  }, [confirmar]);

  useEffect(() => {
    const tecla = async (e) => {
      // Con modales anidados, ESC actúa sobre el de arriba: el último en la página.
      const todos = document.querySelectorAll('[data-fondo-modal]');
      if (e.key !== 'Escape' || !esc || todos[todos.length - 1] !== fondo.current || Swal.isVisible?.()) return;
      if (await seguirSinGuardar()) cerrar.current?.();
    };
    document.addEventListener('keydown', tecla);
    return () => document.removeEventListener('keydown', tecla);
  }, [esc, seguirSinGuardar]);

  // Lo de un modal anidado no cuenta para este: cada fondo atiende solo lo suyo.
  const esMio = (e) => e.target.closest?.('[data-fondo-modal]') === fondo.current;
  const alEditar = (e) => { if (esMio(e)) cambios.current = true; };
  // X, Cancelar y Cerrar: con cambios se confirma primero y después el botón hace lo que siempre hace.
  const alClic = async (e) => {
    const boton = e.target.closest?.('button');
    if (!boton || !esMio(e) || !confirmar || !cambios.current || boton.type === 'submit' || !esBotonDeCierre(boton)) return;
    e.preventDefault(); e.stopPropagation();
    if (await seguirSinGuardar()) boton.click();
  };

  return <div ref={fondo} data-fondo-modal="" className={className} style={style} role="presentation"
    onInputCapture={alEditar} onChangeCapture={alEditar} onClickCapture={alClic}>{children}</div>;
}
